import styled from 'styled-components';

// Title label + event name. In a row it takes the space Date and Location leave
// (never more than its own content, so the row stays packed at the start);
// long names wrap instead of squeezing Date/Location or overflowing.
export const EventNameBlock = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
  min-width: 0;
  max-width: max-content;
`;

// Typography comes from the global h2; long words break instead of clipping.
export const EventName = styled.h2`
  word-break: break-word;
  overflow-wrap: anywhere;
`;
